import { postData } from "./PostData";

const OrderBumps = {
  el: null,

  init() {
    this.el = document.getElementById("order-bumps");
    this.events();
    this.thankYou();
  },

  events() {
    jQuery(document).on("click", "[data-ob-open]", (e) => {
      console.log(OrderBumps.valid());

      if (OrderBumps.valid()) {
        e.preventDefault();

        const miniCartEl = document.getElementById("mini-cart");
        if (miniCartEl) {
          miniCartEl.style.display = "none";
        }

        this.el.classList.add("visible");

        OrderBumps.startTimer();
      }
    });

    jQuery(document).on("click", "[data-product]", (e) => {
      e.preventDefault();
      const btnEl = e.target;

      const orderBumps = sessionStorage.getItem("order-bumps");
      let prods = orderBumps ? JSON.parse(orderBumps) : [];

      const product = btnEl.getAttribute("data-product");
      if (prods.includes(product)) {
        prods = prods.filter((prod) => prod !== product);

        btnEl.innerHTML = my_ajax_object.add_to_cart;
      } else {
        prods.push(product);

        btnEl.innerHTML = my_ajax_object.remove_from_cart;
      }

      sessionStorage.setItem("order-bumps", JSON.stringify(prods));
    });

    jQuery(document).on("click", "[data-ob-close]", () => {
      window.location = my_ajax_object.checkout_url;
    });

    jQuery(document).on("click", "[data-ob-reject]", () => {
      window.location = my_ajax_object.checkout_url;
    });

    jQuery(document).on("click", "[data-ob-order]", (e) => {
      e.preventDefault();
      this.handleSubmit();
    });
  },

  valid() {
    const isValid = document.querySelector("[data-ob-valid]").dataset.obValid;
    return isValid == "1";
  },

  handleSubmit() {
    const nonce = this.el.querySelector("[name=ob-nonce]").value;

    const orderBumps = sessionStorage.getItem("order-bumps");
    const prods = orderBumps ? JSON.parse(orderBumps) : [];

    if (prods.length === 0) {
      window.location = my_ajax_object.checkout_url;
      return;
    }

    document.getElementById("loader").style.display = "flex";

    const formData = new FormData();
    formData.append("action", "cl_ob_product");
    formData.append("nonce", nonce);
    formData.append("products", prods);

    const params = new URLSearchParams(formData);

    postData(my_ajax_object.ajax_url, params).then((data) => {
      // data.button
      if (data.success) {
        window.location = data.redirect;
      }
    });
  },

  startTimer() {
    const timerMinutes = jQuery("#ob-timer-m");
    const timerSeconds = jQuery("#ob-timer-s");

    let countdownTime = 600;

    let countdown = setInterval(function () {
      // Calculate minutes and seconds
      let minutes = Math.floor(countdownTime / 60);
      let seconds = countdownTime % 60;

      // Add leading zero if minutes < 10
      if (minutes < 10) {
        minutes = "0" + minutes;
      }

      // Add leading zero if seconds < 10
      if (seconds < 10) {
        seconds = "0" + seconds;
      }

      // Update the timer display
      timerMinutes.text(minutes);
      timerSeconds.text(seconds);

      // Reduce countdown time by 1 second
      countdownTime--;

      // Check if countdown has reached zero
      if (countdownTime < 0) {
        clearInterval(countdown); // Stop the countdown
      }
    }, 1000);
  },

  /**
   * Clear session storage on thank you page
   */
  thankYou() {
    if (!document.body.classList.contains("woocommerce-order-received")) {
      return;
    }

    sessionStorage.setItem("order-bumps", JSON.stringify([]));
  },
};

export default OrderBumps;
